import React from 'react';
import './Projects.css';
import cemsImg from '../assets/images/cems.png';

const Projects = () => {
  const projects = [
    {
      icon: 'fa-folder-open',
      title: 'Document Management System (DMS)',
      year: '2025',
      description: 'Developed a full-stack DMS for document upload, categorization, and retrieval with secure encryption for confidential files. Implemented NLP for content-based summarization and search alongside full-text/metadata search.',
      github: '#',
      tech: ['Django', 'Angular', 'PostgreSQL', 'NLP']
    },
    {
      icon: 'fa-newspaper',
      title: 'Fake News Detection',
      year: '2025',
      description: 'Built and evaluated models (Bi-LSTM, Transformer) on the ISOT dataset, achieving 98.84% accuracy.',
      github: '#',
      tech: ['Python', 'TensorFlow', 'NLP']
    },
    {
      icon: 'fa-image',
      title: 'Secure Image Steganography System',
      year: '2025',
      description: 'Designed a system to hide encrypted data within images using blue-channel manipulation and a Magic Matrix.',
      github: '#',
      tech: ['Python', 'Cryptography', 'Image Processing']
    },
    {
      image: cemsImg,
      icon: 'fa-calendar-alt',
      title: 'Campus Event Management System (CEMS)',
      year: '2024',
      description: 'Built a Django-based system for event creation, scheduling, and user role management.',
      github: 'https://github.com/nimishathallapally/DBMS',
      tech: ['Django', 'HTML', 'CSS']
    }
  ];

  return (
    <section id="projects" className="projects">
      <div className="container">
        <h1 className="section-title">Projects</h1>
        <div className="projects-grid">
          {projects.map((project, index) => (
            <div key={index} className="project-card">
              <div className="project-icon-header">
                <div className="icon-circle">
                  <i className={`fas ${project.icon}`}></i>
                </div>
                <span className="project-year">{project.year}</span>
              </div>
              <h2>{project.title}</h2>
              <p className="project-description">{project.description}</p>
              <div className="tech-stack">
                {project.tech.map((tech, idx) => (
                  <span key={idx} className="tech-tag">{tech}</span>
                ))}
              </div>
              {project.github && project.github !== '#' && (
                <a href={project.github} className="github-link" target="_blank" rel="noopener noreferrer">
                  <i className="fa-brands fa-github"></i>
                  <span>View on GitHub</span>
                </a>
              )}
              {/* Uncomment when GitHub repos are ready:
              <a href={project.github} className="github-link" target="_blank" rel="noopener noreferrer">
                <i className="fa-brands fa-github"></i>
                <span>View on GitHub</span>
              </a>
              */}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
